"use client";
import { AuthHeader } from "@/components/layout/auth/Header";
import AuthLayout from "@/components/layout/web/AuthLayout";
import Link from "next/link";

const SignInLayout = ({ children, dictionary }) => {
  return (
    <>
      <AuthLayout>
        <AuthHeader>
          <div className=" hidden md:block text-greyDark">
            {dictionary.dontHaveAnAccount}{" "}
            <Link href="/signup" className="text-primary no-underline">
              {dictionary.signUp}
            </Link>
          </div>
        </AuthHeader>
        {children}
      </AuthLayout>
    </>
  );
};

export default SignInLayout;
